import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="40" height="30" viewBox="0 0 40 30" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M0 13.52s4.25-2.66 5.63-3.16c.6 1.08 5.03 8.2 5.72 9.87C13.52 18.16 27.34 2.66 39.77 0A20.8 20.8 0 0138 2.57S16.58 16.38 13.52 30H9.38S4.84 19.84 0 13.52z" /></svg>);